import { render, staticRenderFns } from "./UpgradeSection.vue?vue&type=template&id=cfc240fa&scoped=true&"
var script = {}
import style0 from "./UpgradeSection.vue?vue&type=style&index=0&id=cfc240fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc240fa",
  null
  
)

export default component.exports